import { useLingui } from "@lingui/react/macro";
import { type ServerAgentStatus } from "@t3tools/contracts";
import { memo } from "react";
import { InfoIcon } from "lucide-react";
import { cn } from "~/lib/utils";

export const ProviderStatusBanner = memo(function ProviderStatusBanner({
  status,
}: {
  status: ServerAgentStatus | null;
}) {
  const { t } = useLingui();
  if (!status || status.status === "ready") {
    return null;
  }

  const title =
    status.status === "warning"
      ? t`The agent has limited availability`
      : status.auth.status === "unauthenticated"
        ? t`The agent is not signed in`
        : t`The agent is unavailable`;

  return (
    <div className="mx-auto w-fit max-w-[calc(100%-2rem)] pt-3">
      <div
        className={cn(
          "inline-flex items-center gap-3 rounded-xl border px-3.5 py-3 text-card-foreground text-sm",
          status.status === "warning"
            ? "border-warning/32 bg-warning/4 [&_svg]:text-warning"
            : "border-destructive/32 bg-destructive/4 text-destructive-foreground [&_svg]:text-destructive",
        )}
        role="alert"
      >
        <InfoIcon className="size-4 shrink-0" aria-hidden />
        <div className="flex min-w-0 flex-col gap-1">
          <div className="font-medium">{title}</div>
          <div className="text-muted-foreground">{t`Contact your administrator if this persists.`}</div>
        </div>
      </div>
    </div>
  );
});
